import type { Resource } from '../../';
export const product_sizeChart_measurements_inches: Resource = {"default":"in"};
